export default {
  main: '#fad2dc',
  secondary: '#0f1e82',
  contrastingColor: '#000000',
  priceColor: '#0f1e82',
  entryBackground: '#fad2dc',
  menuBackgroundColor: '#fad2dc',
  menuTextColor: '#000000',
};
